<div class="myCard">
  <router-outlet></router-outlet>
</div>
